// extracted by mini-css-extract-plugin
export var actions = "_rb-4";
export var item = "_rb-1";
export var price = "_rb-3";
export var quantity = "_rb-2";
export var table = "_rb-0";